import { Helmet } from "react-helmet-async";
import { LANGS } from "./types";
import { localizePath, useLang } from "./routing";

// Public origin the site is served from. Used to build canonical + hreflang URLs.
export const SITE_URL = "https://optify.ro";

const DEFAULT_OG_IMAGE = "https://optify.ro/avatar-brand.png";

type Props = {
  /** Canonical path written in the default language, e.g. "/" or "/module/programari". */
  path: string;
  title: string;
  description: string;
  image?: string;
};

export function Seo({ path, title, description, image = DEFAULT_OG_IMAGE }: Props) {
  const lang = useLang();
  const canonical = SITE_URL + localizePath(path, lang);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {LANGS.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={SITE_URL + localizePath(path, l)} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={SITE_URL + path} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      {image === DEFAULT_OG_IMAGE && (
        <meta property="og:image:width" content="1024" />
      )}
      {image === DEFAULT_OG_IMAGE && (
        <meta property="og:image:height" content="1024" />
      )}
      <meta property="og:image:alt" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
